export const processInputs = (input) => {
  return input.trim().replace(/\s+/g, " ");
};

export const getParkShortName = (parkname) => {
  const skipWords = [
    "and",
    "the",
    "of",
    "in",
    "on",
    "at",
    "for",
    "with",
    "a",
    "an",
  ];
  return parkname
    .split(" ")
    .filter((word) => !skipWords.includes(word.toLowerCase()))
    .map((word) => word[0].toUpperCase())
    .join("");
};
